module.exports = __webpack_public_path__ + "assets/8d301943.png";


//////////////////
// WEBPACK FOOTER
// ./src/header/clock.png
// module id = 208
// module chunks = 0